<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import config from "../../../../../../configHttp.js";
import { balancePage } from "../../../../../api/home.js";
export default {
  name: "",
  components: {},
  data: function () {
    return {
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      tableData: [],
      shaidiag: false,
      searchdiag: false,
      tablekey: 0,
      overlength: 0,
    };
  },
  mounted() {},
  created() {
    this.balancePage();
  },
  methods: {	  
    geOoverLength(e){
		  this.overlength = e;
	  },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.balancePage();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.balancePage();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.balancePage();
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.balancePage();
    },
    balancePage() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = "";
      params.order = "";
      balancePage(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.tableData = res.data.data.records;
      });
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    //导出列表：
    exportExcel() {
      //得到勾选的列表值：
      var chooseitem = this.$refs.tablebox.getSelectionval();
	
      if(!this.$emptyandnull(chooseitem)){
          this.searchdata.ids = chooseitem.map((item) => item.id).join(",")
      }
      let params = {
        downUrl: config.baseURL + "/balance/exportExcel",
        typeObj: {
          toForm: true,
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params: JSON.parse(JSON.stringify(this.searchdata)),
      };
      this.$downloadcommon(params);
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
